<template>
  <div class="container">
    <div v-if="galleryShown">
      <button class="button mb" @click="backCat()">Back</button>
      <div class="columns mt is-multiline">
        <div class="column is-one-quarter-desktop is-half-tablet is-narrow" v-for="galla in galla" :item="galla" :key="galla.id">
          <div class="card">
            <div class=" card-image" @click="loadGallery(galla.id)">
              <figure class="image is-4by3">
                <img :src="galla.coverPhoto" alt="">
              </figure>
            </div>
            <footer class="card-footer">
              <a class="card-footer-item" @click="loadGallery(galla.id)">
                {{galla.eventName}}
              </a>
            </footer>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!galleryShown">
      <button class="button mb" @click="back()">Back</button>
      <div class="columns is-hidden-mobile">
        <div class="column ">
          <button class="button is-pulled-right" @click="galleryBack()">&#60;</button>
        </div>
        <div class="column ">
          <p class="image imageSize image">
            <img :src="singleImage" alt="">
          </p>
        </div>
        <div class="column ">
          <button class="button is-pulled-left" @click="galleryForward()">&#62;</button>
        </div>
      </div>
      <div class="columns is-multiline mt">
        <div @click="showImage(image.url, image.id)" class="column is-one-quarter-desktop is-half-tablet" v-for="image in singleGallery" :key="image.id">
          <figure class="image gallerySize ">
            <img class="imgGallery" :src="image.url" alt="">
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from '../http';

export default {
  name: 'Gallery',

  data() {
    return {
      hideGallery: false,
      galleryShown: true,
      singleGallery: null,
      singleImage: null,
      index: null,
      isActive: false,
      galleryArray: null,
      galleryLength: null,
      galleryArrayNum: null,
    };
  },

  created() {
    this.load();
  },
  methods: {
    load() {
      this.$store.dispatch('gallery/load', this.$route.params.gallery);
      this.$store.dispatch('gallery/galla', this.$route.params.galla);
    },
    backCat() {
      this.$router.replace('/weddings-&-events');
    },
    loadGallery(galleryId) {
      this.galleryArrayNum = galleryId - 1;

      this.hideGallery = true;
      this.galleryShown = false;

      this.galleryLength = this.$store.state.gallery.gallery[this.galleryArrayNum].imageUrls.length;

      let temp = [];

      for (let index = 0; index < this.$store.state.gallery.gallery[this.galleryArrayNum].imageUrls.length; index++) {
        temp.push({
          id: index,
          url: this.$store.state.gallery.gallery[this.galleryArrayNum].imageUrls[index],
        });
      }
      this.singleGallery = temp;
      this.galleryForward();
    },

    back() {
      this.galleryShown = true;
      this.hideGallery = false;
      this.singleGallery = null;
    },
    showImage(url, index) {
      this.singleImage = url;
      this.isActive = true;
      this.index = index;
    },
    galleryForward() {
      if (this.galleryLength - 1 === this.index) {
        this.index = 0;
        this.singleImage = this.$store.state.gallery.gallery[this.galleryArrayNum].imageUrls[0];
      } else {
        let newIndex = this.index;
        newIndex++;
        this.singleImage = this.$store.state.gallery.gallery[this.galleryArrayNum].imageUrls[newIndex];
        this.index = newIndex;
      }
    },
    galleryBack() {
      if (this.galleryLength - 1 === this.index) {
        this.index = 0;
        this.singleImage = this.$store.state.gallery.gallery[this.galleryArrayNum].imageUrls[0];
      } else {
        let newIndex = this.index;
        newIndex++;
        this.singleImage = this.$store.state.gallery.gallery[this.galleryArrayNum].imageUrls[newIndex];
        this.index = newIndex;
      }
    },
  },
  computed: {
    gallery() {
      return this.$store.state.gallery.gallery;
    },
    galla() {
      return this.$store.state.gallery.galla;
    },
  },
};
</script>

<style>
.imageSize {
  margin: 0px auto;
}
.gallerySize {
  width: 260px;
  height: 200px;
  overflow: hidden;
  margin: 5px;
  position: relative;
  margin: 0px auto;
}
.imgGallery {
  position: absolute;
  left: -100%;
  right: -100%;
  top: -110%;
  bottom: -110%;
  margin: auto;
  min-height: 100%;
  min-width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/components/Galla.vue